/*eslint-disable*/
import React, { useEffect } from 'react'
import AOS from 'aos'

const Hero = () => {
  useEffect(() => {
    AOS.init({ once: true })
  }, [])
  return (
    <div className='w-full flex items-center flex-wrap pb-8 sm:pb-10 md:pb-12'>
      <div className='w-full md:w-1/2 px-4 md:pl-8 lg:pl-16'>
        <div className='text-left sm:pl-4 lg:pl-10'>
          <h1
            className='text-3xl sm:text-4xl md:text-5xl lg:leading-tight tracking-tight font-bold text-gray-900'
            data-aos='flip-up'
            data-aos-duration='1000'
          >
            Looking to know the <br className='hidden md:block' /> Services we
            offer?
          </h1>

          <p className='my-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0'>
            In addition to assisting travellers in getting from point A to point
            B, we also aid in the delivery and receipt of consignments, develop
            innovative bus hiring strategies, and assist businesses in offering
            a smooth employee travel experience. Additionally, constantly assist
            couriers and drivers with on-time deliveries
          </p>
        </div>
      </div>

      <div className='w-full md:w-1/2'>
        <div className=''>
          <img
            className='w-full sm:w-5/6 mx-auto object-cover'
            src='/assets/images/bus-services/img-01.png'
            alt=''
            data-aos='zoom-in'
            data-aos-duration='1000'
          />
        </div>
      </div>
    </div>
  )
}

export default Hero
